<template>
  <div @click="onClose" id="modal_wrap">
    <div class="modal_container card">
      <div class="card-header">
        <h4 class="mb-0">Управление предоплатой</h4>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <p>
              Заявка:
              <strong
              >{{ modalData.order.id }} ({{
                  $AllProjects[modalData.order.site_id].name
                }})</strong
              >
            </p>
            <p>
              Клиент:
              <strong>{{ modalData.order.client_name }}</strong>
            </p>
            <p>
              email:
              <strong>{{
                  (modalData.order.extra_options &&
                    modalData.order.extra_options.email) ||
                  "не указан"
                }}</strong>
            </p>
            <label for="">Телефоны</label>
            <p v-for="phone in modalData.order.order_phones">
              <strong>+7{{ phone.phone.phone }}</strong>
            </p>
            <template v-if="modalData.order.credit_card_id">
              <div class="alert alert-info p-2">
                <p>К заявке уже прикреплена карта</p>
                <p><strong>{{ selectedCardObject.number }}</strong></p>
                <p>{{ selectedCardObject.owner.name }}</p>
              </div>
            </template>
            <div v-if="historyEmail.length">
              <p>Отправленные письма</p>
              <div v-for="m in historyEmail" class="flex">
                <span>{{ printDate(m.created_at) }}</span>
                <div class="ml-2">
                  <v-popover
                    popoverClass="popover_trace_letter_body"
                    placement="right"
                    popoverInnerClass="small_email_tarce_tooltip"
                    trigger="hover"
                    :delay='{ show: 150, hide: 500 }'
                  >
                    <i class="icon-fa icon-fa-info info_fa"/>
                    <template slot="popover">
                      <div v-html="m.data.letter.body"/>
                    </template>
                  </v-popover>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <pulse-loader
              :loading="loading"
              :color="loadingColor"
              style="text-align: center"
            />
            <div v-if="!loading">
              <div v-if="errorMessage">
                {{ errorMessage }}
              </div>
              <div v-else>
                <div class="mb-2">
                  <p>Выберите тип письма</p>
                  <select @change="updateSelectedLetter" v-model="selectedLetter" class="form-control">
                    <option value="0" disabled>Выберите шаблон письма</option>
                    <option v-for="letter in letters" :value="letter.id">{{ letter.subject.substring(0, 40) }} ...
                    </option>
                  </select>
                </div>
                <template v-if="letter && +letter.type === 2">
                  <div>
                    <select v-model="selectedCard" :disabled="disabledChangeCard" class="form-control">
                      <option value="0" disabled>Выберите карту</option>
                      <option v-for="card in cards" :value="card.id">{{ card.number }} {{ card.owner.name }}
                        ({{ card.totalSum }})
                      </option>
                    </select>
                    <div class="mt-2">
                      <p>Статистика по картам за 7 дней
                        <button v-if="!showCardStatistics" @click="showCardStatistics = true"
                                class="ml-2 btn btn-default">показать статистику
                        </button>
                      </p>
                      <table v-if="showCardStatistics" class="table table-sm table-hover mt-1 mb-1">
                        <thead>
                        <tr>
                          <th>Карта</th>
                          <th>Не оплачено</th>
                          <th>Оплачено</th>
                          <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="card in cards">
                          <td>{{ card.number }}</td>
                          <td>
                            <template v-if="lastPayments[card.id] && lastPayments[card.id][0]">
                              <strong>{{ lastPayments[card.id][0].totalSum }}
                                ({{ lastPayments[card.id][0].payments }})</strong>
                            </template>
                            <template v-else>
                              Пусто
                            </template>
                          </td>
                          <td>
                            <template v-if="lastPayments[card.id] && lastPayments[card.id][1]">
                              <strong>{{ lastPayments[card.id][1].totalSum }}
                                ({{ lastPayments[card.id][1].payments }})</strong>
                            </template>
                            <template v-else>
                              Пусто
                            </template>
                          </td>
                          <td>
                            <template v-if="!disabledChangeCard">
                              <button @click="selectedCard = card.id" class="btn btn-default btn-xs">Выбрать</button>
                            </template>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <template v-if="letter">
              <LetterEdit ref="letter" :letter="letter" :card="card" :order="modalData.order"/>
            </template>
          </div>
        </div>
      </div>
      <div class="card-footer" v-if="!modalData.disableFooter">
        <div class="flex justify-content-end">
          <button @click="onModalClose" class="btn btn-default">Отмена</button>
          <vue-ladda
            type="button"
            button-class="btn btn-success"
            @click="sendLetter"
            data-style="zoom-in"
            :loading="acceptBtnLoading"
          >Отправить
          </vue-ladda>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import VueLadda from "vue-ladda/src/vue-ladda.vue";
import api from "@/api";
import LetterEdit from "@/components/settings/letters/components/LetterEdit";
import VTooltip from 'v-tooltip'

export default {
  components: {
    VueLadda,
    LetterEdit,
    VTooltip,
  },
  data() {
    return {
      showCardStatistics: false,
      types: {
        1: "Поступление почтовой заявки",
        2: "Письмо с реквизитами оплаты",
        3: "Поступление курьерской заявки",
        6: "Отправка почтового трек номера"
      },
      selectedType: 0,
      loading: false,
      acceptBtnLoading: false,
      errorMessage: null,
      loadingColor: this.$constants.LOADING_COLOR,
      letters: [],
      cards: [],
      lastPayments: [],
      selectedCard: 0,
      selectedCardObject: {},
      selectedLetter: 0,
      letter: null,
      card: null,
      sendMessageError: null,
      disabledChangeCard: false,
      historyEmail: [],
    };
  },
  props: ["onModalClose", "onModalAccept", "modalData"],
  watch: {
    selectedCard() {
      this.buidTemplate();
    },
    selectedLetter() {
      this.buidTemplate();
    }
  },
  computed: {
    $AllProjects() {
      const stores = this.$store.getters["platform/projects"].filter(
        s => s.id && s.id !== 4
      );
      const sortedStores = stores.reduce((acc, s) => {
        acc[s.id] = {...s};
        return acc;
      }, {});
      return sortedStores;
    }
  },
  mounted() {
    this.getLetters();
    if (this.modalData.order.credit_card_id) {
      this.disabledChangeCard = true;
      this.selectedCard = this.modalData.order.credit_card_id;
    }
  },
  methods: {
    updateSelectedLetter() {
      this.letter = this.letters.find((l) => l.id === +this.selectedLetter);
    },
    buidTemplate() {
      // if (!this.selectedCard) return;
      this.card = this.cards.find((c) => c.id === +this.selectedCard);
    },
    async getLetters() {
      this.loading = true;
      this.errorMessage = null;
      const {data} = await api.index(
        "orders/getLettersByOrder/" + this.modalData.order.id
      );
      if (data.success) {
        this.lastPayments = data.lastPayments.reduce((acc, c) => {
          if (!acc[c.card_id]) acc[c.card_id] = {};
          acc[c.card_id][c.status] = c;
          return acc;
        }, {});
        this.cards = _.orderBy(data.cards.map((c) => {
          return {
            ...c,
            totalSum: +(this.lastPayments[c.id] && this.lastPayments[c.id][0] && this.lastPayments[c.id][0].totalSum || 0) + +(this.lastPayments[c.id] && this.lastPayments[c.id][1] && this.lastPayments[c.id][1].totalSum || 0)
          }
        }), 'totalSum');
        this.historyEmail = data.emailSent;
        this.letters = data.letters;
        if (!this.selectedCard) {
          this.selectedCard = this.cards[0].id;
        }
        this.selectedCardObject = this.cards.find((c) => c.id === this.selectedCard);
      } else {
        this.errorMessage = data.message;
      }
      this.loading = false;
    },
    async sendLetter() {
      if (!this.selectedLetter || (this.letter.type === 2 && !this.selectedCard)) {
        toastr["warning"]("Выберите карту и шаблон", "Ошибка");
        return;
      }
      this.acceptBtnLoading = true;
      const {data} = await api.post("orders/sendMailLetter", {
        order_id: this.modalData.order.id,
        letter: this.$refs.letter.getLetterText(),
        letter_id: this.selectedLetter,
        card_id: this.selectedCard
      });
      if (data.success) {
        toastr["success"]("Отправлено", "Успешно");
        this.onModalClose();
      } else {
        toastr["warning"](data.message || "ошибка сервера", "Неуспешно");
      }
      this.acceptBtnLoading = false;
    },
    onAccept(e) {
      this.sendMessageError = null;
      if (!this.selectedType) {
        this.sendMessageError = "Выберите тип письма для отправки";
        return;
      }
      this.sendLetter();
    },
    onReject(e) {
      if (!this.acceptBtnLoading) {
        this.onModalClose();
      }
    },
    onClose(e) {
      if (
        !this.acceptBtnLoading &&
        e.target.id === "modal_wrap" &&
        !this.acceptBtnLoading
      ) {
        this.onModalClose();
      }
    }
  }
};
</script>

<style>
.small_email_tarce_tooltip {
  width: 80%;
  font-size: 12px;
}

.small_email_tarce_tooltip p {
  margin-bottom: 0;
}

.modal_body p {
  margin-bottom: 2px;
}
</style>

<style scoped>
.info_fa {
  padding: 1px 5px;
  background-color: #5BBFDE;
  cursor: pointer;
  border-radius: 50%;
}

table.table td {
  padding: 3px;
}

.letter_body {
  margin-top: 10px;
  padding: 10px;
  border: 1px solid lightgray;
}

.card-body {
  overflow: auto;
}

p {
  margin-bottom: 2px;
}

.btn-xs {
  font-size: 12px;
  padding: 1px 8px !important;
  margin: 0;
  margin-bottom: 5px;
}

.modal_container {
  max-height: 80%;
  overflow: hidden;
  overflow-y: auto;
}

.swal2-icon {
  margin: 5px 3px !important;
}

.error_messages {
  color: red;
}

#modal_wrap {
  display: none;
  position: fixed;
  z-index: 99999;
  background-color: rgba(0, 0, 0, 0.55);
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal_body {
  z-index: 1;
  justify-content: center;
  margin: 0;
  padding: 0;
  color: #545454;
  font-size: 1.125em;
  font-weight: 400;
  line-height: normal;
  text-align: center;
  word-wrap: break-word;
}

.modal_header {
  position: relative;
  max-width: 100%;
  margin: 0 0 0.4em;
  padding: 0;
  color: #595959;
  font-size: 1.875em;
  font-weight: 600;
  text-align: center;
  text-transform: none;
  word-wrap: break-word;
}

.modal_actions {
  display: flex;
  z-index: 1;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 1.25em auto 0;
}

.modal_container {
  background-color: white;
  padding: 20px;
  min-width: 70%;
  min-height: 330px;
  width: fit-content;
}
</style>
